// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* One shipment row on the user dashboard. */

.ql-card {
  display: flex;
  flex-direction: column;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid rgba(203, 213, 225, 0.75);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  transition: box-shadow 180ms ease, border-color 180ms ease, transform 180ms ease;
}
.ql-card:hover {
  box-shadow: 0 14px 34px -18px rgba(15, 23, 42, 0.28);
  border-color: rgba(148, 163, 184, 0.85);
}
.dark .ql-card {
  background: #111a2e;
  border-color: rgba(51, 65, 85, 0.6);
  box-shadow: none;
}
.dark .ql-card:hover { border-color: rgba(71, 85, 105, 0.9); }

.ql-card.is-selected { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.14); }
.ql-card.is-highlighted { animation: ql-card-pulse 2.2s ease-out 1; }
@keyframes ql-card-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0); }
  25%      { box-shadow: 0 0 0 5px rgba(59, 130, 246, 0.28); }
}

.ql-card__main { flex: 1 1; min-width: 0; }

@media (min-width: 1024px) {
  .ql-card { flex-direction: row; align-items: stretch; }
}

/* ── route strip ─────────────────────────────────────────────────────────── */
.ql-card__route {
  position: relative;
  min-height: 76px;
  background: linear-gradient(180deg, #f7faff 0%, #eef4ff 100%);
  border-bottom: 1px solid rgba(203, 213, 225, 0.6);
}
.dark .ql-card__route {
  background: linear-gradient(180deg, #223052 0%, #1c2744 100%);
  border-bottom-color: rgba(71, 85, 105, 0.5);
}

/* World-map strip behind the route. Both files are pale, so on a dark card it
   is dropped to a hint rather than painting the header light. */
.ql-card__routebg {
  position: absolute;
  inset: 0;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  pointer-events: none;
}
.dark .ql-card__routebg { opacity: 0.55; }

.ql-card__checkslot {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: 18px;
}

.ql-card__check {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  accent-color: #2563eb;
  cursor: pointer;
}

.ql-card__port {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 21px;
  line-height: 1.15;
  font-weight: 800;
  letter-spacing: 0.01em;
  color: #0f172a;
}
.ql-card__port--right { justify-content: flex-end; }
.dark .ql-card__port { color: #f1f5f9; }
.ql-card__flag { font-size: 21px; line-height: 1; }

.ql-card__city {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dark .ql-card__city { color: #8da2c0; }

/* The two ends share the row evenly, whatever their text runs to — otherwise
   a long destination ("LONDON - HEATHROW, UNITED KINGDOM") drags the carrier
   pill off-centre, and the pills no longer line up down the list. */
.ql-card__end {
  flex: 1 1;
  min-width: 0;
}

.ql-card__leg {
  /* grows, so the dashes have room to draw — with the two ends on an equal
     basis the pill still lands in the middle */
  flex: 1 1 auto;
  min-width: 56px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ql-card__dash {
  flex: 1 1;
  height: 0;
  border-top: 1.5px dashed rgba(100, 116, 139, 0.45);
}
.dark .ql-card__dash { border-top-color: rgba(148, 163, 184, 0.35); }

.ql-card__carrier {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 11px;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid rgba(203, 213, 225, 0.9);
  color: #1d4ed8;
  font-size: 11.5px;
  font-weight: 700;
  white-space: nowrap;
}
.dark .ql-card__carrier {
  background: #0f1830;
  border-color: rgba(71, 85, 105, 0.8);
  color: #93c5fd;
}

/* ── fields ──────────────────────────────────────────────────────────────── */
.ql-card__fieldicon {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  margin-top: 1px;
  border-radius: 8px;
  background: #f1f5fb;
  color: #64748b;
}
.dark .ql-card__fieldicon { background: rgba(148, 163, 184, 0.12); color: #94a3b8; }

/* ── action rail ─────────────────────────────────────────────────────────── */
.ql-card__rail {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 16px;
  border-top: 1px solid rgba(226, 232, 240, 0.9);
}
.dark .ql-card__rail { border-top-color: rgba(51, 65, 85, 0.5); }

@media (min-width: 1024px) {
  .ql-card__rail {
    width: 206px;
    flex-shrink: 0;
    justify-content: flex-end;
    border-top: 0;
    border-left: 1px solid rgba(226, 232, 240, 0.9);
  }
  .dark .ql-card__rail { border-left-color: rgba(51, 65, 85, 0.5); }
}

.ql-card__action {
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  width: 100%;
  padding: 9px 12px;
  border: 0;
  border-radius: 11px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: filter 140ms ease, transform 140ms ease;
}
.ql-card__action:hover { filter: brightness(1.07); }
.ql-card__action:active { transform: translateY(1px); }

.ql-card__action--blue   { background: linear-gradient(135deg, #3b82f6, #2563eb); }
.ql-card__action--purple { background: linear-gradient(135deg, #a855f7, #8b5cf6); }
.ql-card__action--green  { background: linear-gradient(135deg, #10b981, #059669); }
.ql-card__action--pink   { background: linear-gradient(135deg, #f472b6, #ec4899); }

/* ── Pay Now ──────────────────────────────────────────────────────────────
   The one button on the card that asks for money, so it earns a little
   motion: a highlight glides across at a steady pace, with a short beat
   between passes so it reads as a pulse rather than a constant shimmer.
   The sweep is linear on purpose — eased, it lurches at the fast end. */
.ql-card__action--pay {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  box-shadow: 0 6px 18px -10px rgba(37, 99, 235, 0.9);
  animation: ql-pay-breathe 2.4s ease-in-out infinite;
}

.ql-card__action--pay::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 45%;
  pointer-events: none;
  background: linear-gradient(100deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.42) 50%,
    rgba(255, 255, 255, 0) 100%);
  transform: translateX(-170%);
  animation: ql-pay-shine 2.4s linear infinite;
}

/* Under the cursor it has your attention already. */
.ql-card__action--pay:hover,
.ql-card__action--pay:hover::after {
  animation-play-state: paused;
}
.ql-card__action--pay:hover::after { opacity: 0; }

@keyframes ql-pay-shine {
  0%   { transform: translateX(-170%); }
  80%  { transform: translateX(330%); }
  100% { transform: translateX(330%); }
}

@keyframes ql-pay-breathe {
  0%, 70%, 100% { box-shadow: 0 6px 18px -10px rgba(37, 99, 235, 0.9); }
  35%           { box-shadow: 0 8px 26px -10px rgba(37, 99, 235, 1); }
}

@media (prefers-reduced-motion: reduce) {
  .ql-card__action--pay,
  .ql-card__action--pay::after { animation: none; }
  .ql-card__action--pay::after { opacity: 0; }
}
.ql-card__action--slate  { background: linear-gradient(135deg, #64748b, #475569); }

.ql-card__paid {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 9px 12px;
  border-radius: 11px;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  color: #047857;
  font-size: 12px;
  font-weight: 800;
}
.dark .ql-card__paid {
  background: rgba(16, 185, 129, 0.12);
  border-color: rgba(16, 185, 129, 0.35);
  color: #6ee7b7;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/ShipmentCard.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,4CAA4C;EAC5C,gBAAgB;EAChB,gFAAgF;AAClF;AACA;EACE,oDAAoD;EACpD,uCAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;AAClB;AACA,uBAAuB,oCAAoC,EAAE;;AAE7D,uBAAuB,qBAAqB,EAAE,8CAA8C,EAAE;AAC9F,0BAA0B,wCAAwC,EAAE;AACpE;EACE,WAAW,yCAAyC,EAAE;EACtD,WAAW,8CAA8C,EAAE;AAC7D;;AAEA,iBAAiB,SAAO,EAAE,YAAY,EAAE;;AAExC;EACE,WAAW,mBAAmB,EAAE,oBAAoB,EAAE;AACxD;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,iDAAiD;AACnD;AACA;EACE,6DAA6D;EAC7D,2CAA2C;AAC7C;;AAEA;gEACgE;AAChE;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,oBAAoB;AACtB;AACA,0BAA0B,aAAa,EAAE;;AAEzC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA,wBAAwB,yBAAyB,EAAE;AACnD,uBAAuB,cAAc,EAAE;AACvC,iBAAiB,eAAe,EAAE,cAAc,EAAE;;AAElD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,uBAAuB,cAAc,EAAE;;AAEvC;;oEAEoE;AACpE;EACE,SAAW;EACX,YAAY;AACd;;AAEA;EACE;+CAC6C;EAC7C,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,SAAS;EACT,kDAAkD;AACpD;AACA,uBAAuB,2CAA2C,EAAE;;AAEpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA,4BAA4B,qCAAqC,EAAE,cAAc,EAAE;;AAEnF,+EAA+E;AAC/E;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,8CAA8C;AAChD;AACA,uBAAuB,uCAAuC,EAAE;;AAEhE;EACE;IACE,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,+CAA+C;EACjD;EACA,uBAAuB,wCAAwC,EAAE;AACnE;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mDAAmD;AACrD;AACA,yBAAyB,wBAAwB,EAAE;AACnD,0BAA0B,0BAA0B,EAAE;;AAEtD,2BAA2B,qDAAqD,EAAE;AAClF,2BAA2B,qDAAqD,EAAE;AAClF,2BAA2B,qDAAqD,EAAE;AAClF,2BAA2B,qDAAqD,EAAE;;AAElF;;;;wEAIwE;AACxE;EACE,qDAAqD;EACrD,mDAAmD;EACnD,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,UAAU;EACV,oBAAoB;EACpB;;;gCAG8B;EAC9B,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA,oDAAoD;AACpD;;EAEE,4BAA4B;AAC9B;AACA,qCAAqC,UAAU,EAAE;;AAEjD;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,2BAA2B,EAAE;EACpC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,gBAAgB,mDAAmD,EAAE;EACrE,gBAAgB,iDAAiD,EAAE;AACrE;;AAEA;EACE;iCAC+B,eAAe,EAAE;EAChD,+BAA+B,UAAU,EAAE;AAC7C;AACA,2BAA2B,qDAAqD,EAAE;;AAElF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB","sourcesContent":["/* One shipment row on the user dashboard. */\n\n.ql-card {\n  display: flex;\n  flex-direction: column;\n  border-radius: 18px;\n  background: #ffffff;\n  border: 1px solid rgba(203, 213, 225, 0.75);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  overflow: hidden;\n  transition: box-shadow 180ms ease, border-color 180ms ease, transform 180ms ease;\n}\n.ql-card:hover {\n  box-shadow: 0 14px 34px -18px rgba(15, 23, 42, 0.28);\n  border-color: rgba(148, 163, 184, 0.85);\n}\n.dark .ql-card {\n  background: #111a2e;\n  border-color: rgba(51, 65, 85, 0.6);\n  box-shadow: none;\n}\n.dark .ql-card:hover { border-color: rgba(71, 85, 105, 0.9); }\n\n.ql-card.is-selected { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.14); }\n.ql-card.is-highlighted { animation: ql-card-pulse 2.2s ease-out 1; }\n@keyframes ql-card-pulse {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0); }\n  25%      { box-shadow: 0 0 0 5px rgba(59, 130, 246, 0.28); }\n}\n\n.ql-card__main { flex: 1; min-width: 0; }\n\n@media (min-width: 1024px) {\n  .ql-card { flex-direction: row; align-items: stretch; }\n}\n\n/* ── route strip ─────────────────────────────────────────────────────────── */\n.ql-card__route {\n  position: relative;\n  min-height: 76px;\n  background: linear-gradient(180deg, #f7faff 0%, #eef4ff 100%);\n  border-bottom: 1px solid rgba(203, 213, 225, 0.6);\n}\n.dark .ql-card__route {\n  background: linear-gradient(180deg, #223052 0%, #1c2744 100%);\n  border-bottom-color: rgba(71, 85, 105, 0.5);\n}\n\n/* World-map strip behind the route. Both files are pale, so on a dark card it\n   is dropped to a hint rather than painting the header light. */\n.ql-card__routebg {\n  position: absolute;\n  inset: 0;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  pointer-events: none;\n}\n.dark .ql-card__routebg { opacity: 0.55; }\n\n.ql-card__checkslot {\n  flex-shrink: 0;\n  display: grid;\n  place-items: center;\n  width: 18px;\n}\n\n.ql-card__check {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  accent-color: #2563eb;\n  cursor: pointer;\n}\n\n.ql-card__port {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 21px;\n  line-height: 1.15;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  color: #0f172a;\n}\n.ql-card__port--right { justify-content: flex-end; }\n.dark .ql-card__port { color: #f1f5f9; }\n.ql-card__flag { font-size: 21px; line-height: 1; }\n\n.ql-card__city {\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748b;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dark .ql-card__city { color: #8da2c0; }\n\n/* The two ends share the row evenly, whatever their text runs to — otherwise\n   a long destination (\"LONDON - HEATHROW, UNITED KINGDOM\") drags the carrier\n   pill off-centre, and the pills no longer line up down the list. */\n.ql-card__end {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.ql-card__leg {\n  /* grows, so the dashes have room to draw — with the two ends on an equal\n     basis the pill still lands in the middle */\n  flex: 1 1 auto;\n  min-width: 56px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ql-card__dash {\n  flex: 1;\n  height: 0;\n  border-top: 1.5px dashed rgba(100, 116, 139, 0.45);\n}\n.dark .ql-card__dash { border-top-color: rgba(148, 163, 184, 0.35); }\n\n.ql-card__carrier {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 11px;\n  border-radius: 999px;\n  background: #ffffff;\n  border: 1px solid rgba(203, 213, 225, 0.9);\n  color: #1d4ed8;\n  font-size: 11.5px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.dark .ql-card__carrier {\n  background: #0f1830;\n  border-color: rgba(71, 85, 105, 0.8);\n  color: #93c5fd;\n}\n\n/* ── fields ──────────────────────────────────────────────────────────────── */\n.ql-card__fieldicon {\n  flex-shrink: 0;\n  display: grid;\n  place-items: center;\n  width: 26px;\n  height: 26px;\n  margin-top: 1px;\n  border-radius: 8px;\n  background: #f1f5fb;\n  color: #64748b;\n}\n.dark .ql-card__fieldicon { background: rgba(148, 163, 184, 0.12); color: #94a3b8; }\n\n/* ── action rail ─────────────────────────────────────────────────────────── */\n.ql-card__rail {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  padding: 16px;\n  border-top: 1px solid rgba(226, 232, 240, 0.9);\n}\n.dark .ql-card__rail { border-top-color: rgba(51, 65, 85, 0.5); }\n\n@media (min-width: 1024px) {\n  .ql-card__rail {\n    width: 206px;\n    flex-shrink: 0;\n    justify-content: flex-end;\n    border-top: 0;\n    border-left: 1px solid rgba(226, 232, 240, 0.9);\n  }\n  .dark .ql-card__rail { border-left-color: rgba(51, 65, 85, 0.5); }\n}\n\n.ql-card__action {\n  position: relative;\n  overflow: hidden;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  width: 100%;\n  padding: 9px 12px;\n  border: 0;\n  border-radius: 11px;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: filter 140ms ease, transform 140ms ease;\n}\n.ql-card__action:hover { filter: brightness(1.07); }\n.ql-card__action:active { transform: translateY(1px); }\n\n.ql-card__action--blue   { background: linear-gradient(135deg, #3b82f6, #2563eb); }\n.ql-card__action--purple { background: linear-gradient(135deg, #a855f7, #8b5cf6); }\n.ql-card__action--green  { background: linear-gradient(135deg, #10b981, #059669); }\n.ql-card__action--pink   { background: linear-gradient(135deg, #f472b6, #ec4899); }\n\n/* ── Pay Now ──────────────────────────────────────────────────────────────\n   The one button on the card that asks for money, so it earns a little\n   motion: a highlight glides across at a steady pace, with a short beat\n   between passes so it reads as a pulse rather than a constant shimmer.\n   The sweep is linear on purpose — eased, it lurches at the fast end. */\n.ql-card__action--pay {\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  box-shadow: 0 6px 18px -10px rgba(37, 99, 235, 0.9);\n  animation: ql-pay-breathe 2.4s ease-in-out infinite;\n}\n\n.ql-card__action--pay::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 45%;\n  pointer-events: none;\n  background: linear-gradient(100deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.42) 50%,\n    rgba(255, 255, 255, 0) 100%);\n  transform: translateX(-170%);\n  animation: ql-pay-shine 2.4s linear infinite;\n}\n\n/* Under the cursor it has your attention already. */\n.ql-card__action--pay:hover,\n.ql-card__action--pay:hover::after {\n  animation-play-state: paused;\n}\n.ql-card__action--pay:hover::after { opacity: 0; }\n\n@keyframes ql-pay-shine {\n  0%   { transform: translateX(-170%); }\n  80%  { transform: translateX(330%); }\n  100% { transform: translateX(330%); }\n}\n\n@keyframes ql-pay-breathe {\n  0%, 70%, 100% { box-shadow: 0 6px 18px -10px rgba(37, 99, 235, 0.9); }\n  35%           { box-shadow: 0 8px 26px -10px rgba(37, 99, 235, 1); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ql-card__action--pay,\n  .ql-card__action--pay::after { animation: none; }\n  .ql-card__action--pay::after { opacity: 0; }\n}\n.ql-card__action--slate  { background: linear-gradient(135deg, #64748b, #475569); }\n\n.ql-card__paid {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  padding: 9px 12px;\n  border-radius: 11px;\n  background: #ecfdf5;\n  border: 1px solid #a7f3d0;\n  color: #047857;\n  font-size: 12px;\n  font-weight: 800;\n}\n.dark .ql-card__paid {\n  background: rgba(16, 185, 129, 0.12);\n  border-color: rgba(16, 185, 129, 0.35);\n  color: #6ee7b7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
